import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import Link from "next/link";

import { useI18n } from "@/i18n/I18nProvider";
import { colors } from "@/utils/const";

import LanguageToggle from "./LanguageToggle";
import MainMenu from "./menus/MainMenu";
import NavPopover from "./menus/NavPopover";
import { AUDIENCE_TABS } from "./navbar.config";
import { audienceTabState, topBar } from "./navbar.styles";

/*
 * The grey strip above the main desktop bar: the corporate menu, the
 * individuals/companies switch and the language toggle.
 */
export default function TopBar({ audience, onSelectAudience }) {
  const { t, locale } = useI18n();
  const [menuAnchor, setMenuAnchor] = useState(null);

  const closeMenu = () => setMenuAnchor(null);

  return (
    <Box sx={topBar.container} className="horizontal-safe-padding">
      <Button
        aria-label="Menu drop down button"
        aria-expanded={Boolean(menuAnchor)}
        onClick={(event) => setMenuAnchor(event.currentTarget)}
        sx={topBar.menuButton}
      >
        {menuAnchor ? (
          <CloseIcon sx={topBar.menuIcon} />
        ) : (
          <MenuIcon sx={topBar.menuIcon} />
        )}
      </Button>

      {AUDIENCE_TABS.map(({ id, href, label }) => (
        <Box
          key={id}
          component={Link}
          href={href}
          onClick={() => onSelectAudience(id)}
          sx={{ ...topBar.audienceTab, ...audienceTabState(audience === id) }}
        >
          {label(t)}
        </Box>
      ))}

      {/* Pushed to the far end of the row, whichever end that is. */}
      <LanguageToggle
        sx={{
          color: colors.blue,
          fontWeight: "bold",
          justifyContent: "end",
          marginInlineStart: "auto",
          "&:hover": { backgroundColor: "transparent" },
        }}
      />

      <NavPopover anchorEl={menuAnchor} onClose={closeMenu} offsetTop={1}>
        <MainMenu onNavigate={closeMenu} />
      </NavPopover>
    </Box>
  );
}
